import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface NotaFiscalConsumidorCancelamentoRequest {
    justificativa: string;
}

export interface NotaFiscalConsumidorCancelamentoResponse {
    status: string;
    status_sefaz: string;
    mensagem_sefaz: string;
    numero_protocolo: string;
    caminho_xml_cancelamento: string;
    caminho_danfe?: string;
}

@Injectable({
    providedIn: 'root'
})
export class InvoiceTaxDocumentConsumerService {

    private apiUrl = `${environment.apiHost}/api-notafiscal/secure/nfconsumidor`;

    constructor(private http: HttpClient) { }

    cancelar(invoiceId: number, request: NotaFiscalConsumidorCancelamentoRequest): Observable<NotaFiscalConsumidorCancelamentoResponse> {
        return this.http.delete<NotaFiscalConsumidorCancelamentoResponse>(`${this.apiUrl}/cancel/${invoiceId}`, {
            body: request
        });
    }

    downloadXml(invoiceId: number): Observable<HttpResponse<Blob>> {
        return this.http.get(`${this.apiUrl}/${invoiceId}/xml`, {
            observe: 'response',
            responseType: 'blob'
        });
    }
}
